import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
export function LogotypeSlideshow(_a) {
    var imgs = _a.imgs;
    SwiperCore.use([Autoplay]);
    var breakpoints = {
        0: {
            slidesPerView: 1,
            spaceBetween: 0
        },
        380: {
            slidesPerView: 2
        },
        540: {
            slidesPerView: 3
        },
        800: {
            slidesPerView: 4
        },
        1200: {
            slidesPerView: 7
        }
    };
    return (React.createElement(Swiper, { slidesPerView: 7, autoplay: { delay: 3000 }, loop: imgs.length > 1, breakpoints: breakpoints, spaceBetween: 10 }, imgs.map(function (path, index) {
        return React.createElement(SwiperSlide, { key: "slide-".concat(index) },
            React.createElement("img", { className: 'logotype-item', height: 40, src: path }));
    })));
}
